import type { Icon } from "@phosphor-icons/react";
import clsx from "clsx";
import { use } from "react";

import { useMenu } from "~/components/Menu";

import type { CreateMenuAction } from "./CreateMenu";
import { CreateMenuContext } from "./CreateMenuContext";

export const CreateOption: React.FC<{
  icon: Icon;
  title: string;
  description: string;
  action: CreateMenuAction;
  className?: string;
}> = ({ icon: Icon, className, title, description, action }) => {
  const { closeMenu } = useMenu();
  const { setAction } = use(CreateMenuContext);
  return (
    <button
      className="flex items-center gap-3 pl-2 text-base"
      onClick={() => {
        closeMenu();
        setAction(action);
      }}
    >
      <div
        className={clsx(
          "flex size-12 shrink-0 self-start rounded-btn border-2 border-current bg-gradient-to-tr",
          className,
        )}
      >
        <Icon weight="duotone" className="m-auto size-8" />
      </div>
      <div>
        <div className="font-medium leading-tight">{title}</div>
        <div className="text-sm leading-tight">{description}</div>
      </div>
    </button>
  );
};
